
export default {
  data() {
    return {
      member: null,
    };
  },
  filters: {
    date(date) {
      return date.match(/^(\d{4}-\d{2}-\d{2})/)[1];
    },
  },
  props: {
    title: {
      type: String,
    },
    date: {
      type: String,
    },
    memberSlug: {
      type: String,
    },
  },
  async fetch() {
    try {
      if (this.memberId !== null) {
        this.member = await this.$strapi.find(`members/${this.memberSlug}`);
      }
    } catch (err) {
      console.error(err);
      console.error({ statusCode: 404, message: err.response });
    }
  },
};
